import React from "react";
import { Alert, Box, Typography } from "@mui/material";
import EntityForm from "../components/EntityForm";
import { createBed } from "../api/coreApi";
import { fkId, sameId } from "../utils/coreHelpers";

export default function BedFormStep({
  loading,
  setLoading,
  setErr,
  refreshAll,
  goNext,
  wards = [],
  rooms = [],
  selectedWardId,
  setSelectedWardId,
  selectedRoomId,
  setSelectedRoomId,
}) {
  if (!wards.length) return <Alert severity="warning">Create Ward first (Step 2).</Alert>;

  const wardOptions = wards.map((w) => ({
    value: fkId(w.ward_id || w.id),
    label: `${w.name} (${w.ward_type || "-"})`,
  }));

  const roomsForWard = rooms.filter((r) =>
    sameId(fkId(r.ward || r.ward_id), selectedWardId)
  );

  const roomOptions = roomsForWard.map((r) => ({
    value: fkId(r.room_id || r.id),
    label: `Room ${r.room_label}`,
  }));

  if (!selectedWardId) return <Alert severity="warning">Select Ward first.</Alert>;
  if (!roomOptions.length) return <Alert severity="warning">Create Room first (Step 3).</Alert>;

  const onSubmit = async (vals, helpers) => {
    setLoading(true);
    setErr("");

    try {
      const payload = {
        ward: selectedWardId,
        room: selectedRoomId,
        bed_label: vals.bed_label,
        is_active: vals.is_active,
      };

      await createBed(payload);

      goNext();
      await refreshAll();
      helpers?.reset?.();
    } catch (e) {
      setErr(e?.response?.data ? JSON.stringify(e.response.data) : "Create bed failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography sx={{ fontWeight: 900, mb: 1 }}>Step 4: Bed</Typography>

      <EntityForm
        title="Create Bed"
        loading={loading}
        initialValues={{
          _ward: selectedWardId || wardOptions[0]?.value || "",
          _room: selectedRoomId || roomOptions[0]?.value || "",
          bed_label: "",
          is_active: true,
        }}
        fields={[
          {
            name: "_ward",
            label: "Ward",
            type: "select",
            required: true,
            options: wardOptions,
          },
          {
            name: "_room",
            label: "Room",
            type: "select",
            required: true,
            options: () => roomOptions,
          },
          { name: "bed_label", label: "Bed Label", required: true, placeholder: "B1 / 01" },
          {
            name: "is_active",
            label: "Active",
            type: "select",
            options: [
              { value: true, label: "True" },
              { value: false, label: "False" },
            ],
          },
        ]}
        onSubmit={(vals, helpers) => {
          if (vals._ward && vals._ward !== selectedWardId) setSelectedWardId(vals._ward);
          if (vals._room && vals._room !== selectedRoomId) setSelectedRoomId(vals._room);
          return onSubmit(vals, helpers);
        }}
      />
    </Box>
  );
}